import { useState } from 'react';
import type { BreadcrumbItem } from '@components/sds/breadcrumb/breadcrumb';
import { Breadcrumb } from '@components/sds/breadcrumb/breadcrumb';
import { DownloadCard } from './components/download-card/download-card';
import { SectionCard } from './components/section-card/section-card';
import type { DocumentSection } from './documents-data';
import { documentsData } from './documents-data';
import styles from './documents.module.scss';

const rootSection: DocumentSection = documentsData;

const getSectionByPath = (path: string[]): DocumentSection => {
  let current = rootSection;

  for (const id of path) {
    const next = current.sections?.find(section => section.id === id);

    if (!next) {
      return rootSection;
    }

    current = next;
  }

  return current;
};

export const Documents = () => {
  const [path, setPath] = useState<string[]>([]);

  const currentSection = getSectionByPath(path);
  const isRootSection = path.length === 0;

  const navigateToSection = (sectionId: string) => {
    setPath([...path, sectionId]);
  };

  const navigateToPath = (newPath: string[]) => {
    setPath(newPath);
  };

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: rootSection.title,
      onClick: () => navigateToPath([]),
    },
  ];

  path.forEach((_id, index) => {
    const currentPath = path.slice(0, index + 1);
    const section = getSectionByPath(currentPath);
    const isLastItem = index === path.length - 1;

    breadcrumbItems.push({
      label: section.title,
      onClick: isLastItem ? undefined : () => navigateToPath(currentPath),
    });
  });

  return (
    <div className={styles.container}>
      {isRootSection ? (
        <h1 className={styles.heading}>{rootSection.title}</h1>
      ) : (
        <Breadcrumb items={breadcrumbItems} />
      )}

      {currentSection.files.map(file => (
        <DownloadCard key={file.title} title={file.title} url={file.url} />
      ))}

      {currentSection.sections?.map(section => (
        <SectionCard
          key={section.id}
          title={section.title}
          onClick={() => navigateToSection(section.id ?? '')}
        />
      ))}
    </div>
  );
};
